import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type MetricStripCols = 2 | 3 | 4 | 5 | 6;

export type MetricStripProps = {
  children: ReactNode;
  cols?: MetricStripCols;
  className?: string;
};

const COL_CLASSES: Record<MetricStripCols, string> = {
  2: "grid-cols-2",
  3: "grid-cols-2 md:grid-cols-3",
  4: "grid-cols-2 md:grid-cols-2 lg:grid-cols-4",
  5: "grid-cols-2 md:grid-cols-3 lg:grid-cols-5",
  6: "grid-cols-2 md:grid-cols-3 lg:grid-cols-6",
};

export function MetricStrip({ children, cols = 4, className }: MetricStripProps) {
  return (
    <div className={cn("grid gap-3", COL_CLASSES[cols], className)}>
      {children}
    </div>
  );
}

export default MetricStrip;
